<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 d-flex justify-content-center">
                <div v-if="user" class="card" style="max-width:630px">
                    <div class="card-body d-flex justify-content-center">
                        <iframe width="640px" height="700px" src="https://forms.office.com/Pages/ResponsePage.aspx?id=PpCp-B8Rq0uZgEq33GN9QyrJkX0l_d9HpLwXMEqRvVxURTZYS0FESjBEV1JBMUJUU0tYS1UzQ0VDMy4u&embed=true" frameborder="0" marginwidth="0" marginheight="0" style="border: none; max-width:100%; max-height:100vh" allowfullscreen webkitallowfullscreen mozallowfullscreen msallowfullscreen> </iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Mgr from '@/services/SecurityService'

    export default {
        components: {
        },
        data() {
            return {
                mgr: new Mgr(),
                user: null
            };
        },
        mounted() {
            this.mgr.getUser().then(
                data => {
                    this.user = data;
                },
                err => {
                    console.log(err)
                }
            );
        }
}
</script>
